// extracted by mini-css-extract-plugin
export var list = "navigation-list-module--list--eGfWT";